import React from 'react';
import { ButtonContentfulModel } from 'src/api/models/Button';
import LinkBranded from 'src/elements/links/Link.branded';
import LinkSimple from 'src/elements/links/Link.simple';

export default function getDynamicButton(buttonProps: ButtonContentfulModel): React.ReactNode {
  return (
    <div style={{ display: 'grid', justifySelf: 'center', marginTop: '24px', marginBottom: '24px' }}>
      {
        buttonProps.variant.includes('primary') ?
          <LinkBranded
            url={buttonProps.url}
            text={buttonProps.text}
            caption={buttonProps.helpText}
            colorScheme={buttonProps.colorScheme}
            justify="center"
            captionJustify="center"
            weight="bold"
          /> :
          <LinkSimple
            url={buttonProps.url}
            color="main"
            text={buttonProps.text}
            colorScheme={buttonProps.colorScheme}
            iconPosition="right"
            justify="center"
          />
      }
    </div>
  );
}
